import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AssistantService } from '../assistant.service';
import { SessionService } from 'src/app/session.service';

@Component({
  selector: 'app-assistant-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class AssistantChatComponent implements OnInit {

  @Input() public integration: any;
  @Input() public content: any;
  @Input() public previewFn!: Function;
  @Input() public closeFn!: Function;
  @ViewChild('messageContainer') private messagesContainer!: ElementRef;

  public chatForm: FormGroup = new FormGroup({
    newMessage: new FormControl('', [Validators.required])
  });

  private thread: any;
  public messages: any[] = [];
  public loading: boolean = false;
  public result: any;

  constructor(
    private svc: AssistantService,
    private sessionSvc: SessionService
  ) { }

  ngOnInit(): void {
    //console.log('AssistantChatComponent', this.content);
    this.loading = true;
    this.updateUX();
    let reqContent = {
      content: this.content
    }
    this.svc.initAssistant(this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, this.integration.id, reqContent).subscribe((result: any) => {
      this.thread = result.thread;
      this.messages = result.messages;
      this.loading = false;
      this.updateUX();
    });
  }

  updateUX() {
    this.chatForm.reset();
    if(this.loading){
      this.chatForm.get('newMessage')!.disable();
    } else {
      this.chatForm.get('newMessage')!.enable();
    }
    //this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    } catch(err) {
      console.error(err);
    }                 
}

  sendMessage() {
    if (this.chatForm.valid) {
      let message = this.chatForm.get('newMessage')!.value;
      this.messages.push({
        content: message,
        role: 'user'
      });
      this.loading = true;
      this.updateUX();
      this.chatForm.get('newMessage')!.setValue('');
      this.svc.sendThreadMessage(this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, this.integration.id, this.thread.id, message).subscribe((result: any) => {
        this.processMessages(result.messages);
        this.loading = false;
        this.updateUX();
      });
    }
  }

  processMessages(messages: any[]) {
    for (let message of messages) {
      if(message.content){
        this.messages.push(message);
      }
      if(message.result){
        //console.log('result', message.result);
        this.result = message.result;
        this.result.data.arguments = JSON.parse(this.result.data.arguments);
        this.preview();
      }
      if(message.complete !== undefined && message.complete){
        // wait a few seconds and then close the chat
        setTimeout(() => {
          // report the assistant results
          this.loading = true;
          this.svc.reportAssistantResult(this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, this.integration.id, this.thread.id, this.result.data.arguments).subscribe((result: any) => {
            this.result = null;
            this.messages = [];
            this.loading = false;
            this.closeFn();
          });
        }, 3000);
      }
    }
  }

  preview() {
    //console.log('chat preview', this.result);
    this.updateUX();
    switch(this.result.data.name){
      case 'signal_content_assistant':
        this.previewFn('mobilePush', {
          resultFn: this.handlePreviewResult.bind(this),
          data: this.result
        });
      break;
    }
  }

  handlePreviewResult(result: any) {
    //console.log('handlePreviewResult', result);
    let req = {
      threadId: this.result.threadId,
      runId: this.result.runId,
      callId: this.result.callId,
      result: result,
    }
    this.loading = true;
    this.svc.reportToolCall(this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, this.integration.id, this.thread.id, req).subscribe((result: any) => {
      //console.log('reportToolCall Response', result);
      this.loading = false;
      this.processMessages(result.messages);
    });
  }

}
